import type { ReactElement } from 'react';
import { PostHogRealTimeDemo } from '#~/posthog/demo.js';
import { Exhibit } from './styled.jsx';

/** `<PostHog>` exhibit for testing real-time feature flags. */
export const PostHog = (): ReactElement => (
  <Exhibit title='PostHog Real-Time Feature Flags'>
    <PostHogRealTimeDemo />
  </Exhibit>
);
